import React from 'react';
import { RouteComponentProps } from 'react-router';

import MarketplacePageWrapper from './marketplace_page_wrapper';
import { MarketplacePathContext } from '../shared/url_helpers';
import {
  core_apimessages_CollectionHeader_CollectionType,
} from '../../schemas/rql';
import { MParticlePageName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

type IProps = RouteComponentProps<{}, MarketplacePathContext>;

export default function HandpickedPage({ params }: IProps) {
  return (
    <MarketplacePageWrapper
      pageSettings={{
        collectionType: core_apimessages_CollectionHeader_CollectionType.CuratedSet,
        collectionSlug: params.curated_set_slug,
        useExperimentalRecall: false,
      }}
      renderCollectionHeaderDescription
      pageName={MParticlePageName.Handpicked}
    />
  );
}
